import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';

const QRGenerator = ({ 
  data, 
  setQrCodeDataUrl, 
  width = 200, 
  height = 200,
  color = '#000000',
  backgroundColor = '#ffffff',
  errorCorrectionLevel = 'M'
}) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Solo generar si hay datos válidos
    if (!data || (typeof data === 'string' && !data.trim())) {
      setQrCodeDataUrl('');
      return;
    }

    const generateQR = async () => {
      setIsGenerating(true);
      setError(null);
      
      try {
        // Convertir el objeto a una cadena JSON si no es una cadena
        const qrData = typeof data === 'string' ? data : JSON.stringify(data);
        
        // Opciones para la generación del QR
        const options = {
          width,
          height,
          margin: 1,
          color: {
            dark: color,
            light: backgroundColor
          },
          errorCorrectionLevel
        };
        
        // Generar el código QR como URL de datos
        const dataUrl = await QRCode.toDataURL(qrData, options);
        setQrCodeDataUrl(dataUrl);
      } catch (err) {
        console.error('Error generando código QR:', err);
        setError('Error al generar el código QR');
      } finally {
        setIsGenerating(false);
      }
    };

    // Añadir un pequeño retraso para evitar demasiadas generaciones durante la escritura
    const timer = setTimeout(() => {
      generateQR();
    }, 300);

    return () => clearTimeout(timer);
  }, [data, width, height, color, backgroundColor, errorCorrectionLevel, setQrCodeDataUrl]);

  if (error) {
    return <div className="alert error">{error}</div>;
  }

  if (isGenerating) {
    return <div className="spinner"></div>;
  }

  return null; // Este componente no renderiza nada, solo actualiza el estado
};

export default QRGenerator;